var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8532 1.45755C6.92325 1.38768 6.97099 1.2986 6.99039 1.20158C7.00979 1.10457 6.99997 1.00398 6.96217 0.912546C6.92438 0.821113 6.86031 0.742948 6.77808 0.687943C6.69584 0.632939 6.59914 0.603567 6.5002 0.603546H0.9142C0.815265 0.603567 0.71856 0.632939 0.636324 0.687943C0.554088 0.742948 0.490019 0.821113 0.452226 0.912546C0.414432 1.00398 0.404614 1.10457 0.424012 1.20158C0.443411 1.2986 0.491154 1.38768 0.561201 1.45755L3.3532 4.24955C3.39965 4.29611 3.45482 4.33305 3.51557 4.35826C3.57631 4.38346 3.64143 4.39644 3.7072 4.39644C3.77297 4.39644 3.83809 4.38346 3.89883 4.35826C3.95958 4.33305 4.01476 4.29611 4.0612 4.24955L6.8532 1.45755Z",
    fill: "#4F5660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b97bc4a9d03481858c57950ba1af51f6.svg";
export { ForwardRef as ReactComponent };